module.exports = __webpack_public_path__ + "static/media/logo_unesco_biosfera.dd5d9a24.webp";